import { runClientComponent } from '../../_common/client/client-component-runner';
import { PriceFeatureComponentComponent } from './price-feature-component.component';

runClientComponent({ PriceFeatureComponentComponent });
